import { Description as DescriptionIcon } from "@mui/icons-material";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

/** Links for trust/safety documents. Replace placeholder "#" with PDF URLs when available. */
const TRUST_LINKS = [
    {
        label: "Recording Policy",
        href: "https://docs.google.com/document/d/1NS_5UJpYahHAoKD9xPzspFyU52GspGwU-Zk_4O0Pgck/export?format=pdf",
        external: true
    },
    {
        label: "Features to Vision",
        href: "https://docs.google.com/document/d/1CmRWSTcSroKIuoT_Ud0Q05LLCOMRq1ycoF3mS9BuEL4/export?format=pdf",
        external: true
    },
    {
        label: "Mandated Reporting Policy",
        href: "https://docs.google.com/document/d/12j2jTncVofnORTEKTvGyY49Lsl9ulU_B8Vn3keeNXkE/export?format=pdf",
        external: true
    },
    {
        label: "Data & Privacy Summary",
        href: "https://docs.google.com/document/d/1FpeubJ0KG6TwkNaqGMGJS7VEFo_z4g56u8nXcJJnpbc/export?format=pdf",
        external: true
    },
    {
        label: "Terms of Use",
        href: "/terms-of-use",
        external: false
    },
    {
        label: "Evidence Based Framework",
        href: "https://docs.google.com/document/d/1WV3YCZWXvM5W0GEJ2DIJYTniPuRksLX7BNuVFVbowmg/export?format=pdf",
        external: true
    },
] as const;

const Trust: React.FC = () => {
    return (
        <Container maxWidth="sm" sx={{ py: 6 }}>
            <Typography variant="h4" component="h1" sx={{ mb: 3, fontWeight: 600 }}>
                Trust, Safety & Evidence
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Download or view our policies and frameworks.
            </Typography>
            <Stack spacing={2}>
                {TRUST_LINKS.map(({ label, href, external }) => (
                    <Box key={label}>
                        {external ? (
                            <Button
                                component="a"
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="outlined"
                                fullWidth
                                startIcon={<DescriptionIcon />}
                                sx={{ justifyContent: "flex-start", py: 1.5, textTransform: "none" }}
                            >
                                {label}
                            </Button>
                        ) : (
                            <Button
                                component={Link}
                                to={href}
                                variant="outlined"
                                fullWidth
                                startIcon={<DescriptionIcon />}
                                sx={{ justifyContent: "flex-start", py: 1.5, textTransform: "none" }}
                            >
                                {label}
                            </Button>
                        )}
                    </Box>
                ))}
            </Stack>
        </Container>
    );
};

export default Trust;
